/** Main Non JUPAS site. Relative paths from the shared template resolve here. */
export const MAIN_SITE = "https://www.nonjupas.hk";
export const TITLE_SUFFIX = " - Non JUPAS 資訊頻道";

export function pageTitle(title: string): string {
  return `${title}${TITLE_SUFFIX}`;
}

export function mainSiteUrl(path: string): string {
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${MAIN_SITE}${normalized}`;
}
